import { motion } from "framer-motion";
import { ArrowRight, Database, Rocket, Target, Users, ArrowUpRight } from "lucide-react";

import Button from "../../Button/Button";
import Card from "../../Card/Card";
import Container from "../../Container/Container";
import IconBox from "../../IconBox/IconBox";
import { fadeLeft, fadeUp, staggerContainer, viewportOnce } from "../../../Utils/animations";
import { scrollToSection } from "../../../Utils/helpers";

import "../../../Style/home/about.css";

const features = [
  {
    id: 1,
    icon: <Rocket size={22} />,
    title: "Digital Marketing",
    text: "Campaigns built around measurable revenue outcomes.",
    href: "/services/email-marketing",
  },
  {
    id: 2,
    icon: <Database size={22} />,
    title: "Data Intelligence",
    text: "Verified, enriched records that keep your CRM clean.",
    href: "/services/data-verification",
  },
  {
    id: 3,
    icon: <Target size={22} />,
    title: "Lead Generation",
    text: "Pipelines targeted at the accounts you actually want.",
    href: "/services/lead-generation",
  },
  {
    id: 4,
    icon: <Users size={22} />,
    title: "Recruitment & Staffing",
    text: "Sourcing support that shortens your time-to-hire.",
    href: "/services/recruitment",
  },
];

/** Split layout: copy + CTA on the left, four feature cards on the right. */
function About() {
  const handleNavigate = (href) => (e) => {
    e.preventDefault();
    if (href.startsWith("#")) {
      scrollToSection(href.replace("#", ""));
      return;
    }
    window.history.pushState({}, "", href);
    window.dispatchEvent(new Event("popstate"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section id="about" className="section section--plain about">
      <Container className="about__grid">
        {/* Left Column: Narrative + CTA */}
        <motion.div
          className="about__copy"
          variants={fadeLeft()}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          <span className="section-eyebrow">
            <span className="section-eyebrow__dot" aria-hidden="true" />
            About Conectify Tech
          </span>

          <h2 className="about__title">
            Turning strategy into <span className="text-gradient">measurable results.</span>
          </h2>

          <p className="section-description">
            We combine data, technology, and intentional targeting to deliver impactful digital marketing and
            business solutions that help enterprises grow, scale, and stay ahead.
          </p>

          <Button
  href="#services"
  icon={<ArrowRight size={18} />}
  className="mt-6"
  onClick={(e) => {
    e.preventDefault();
    const isHome = window.location.pathname === "/" || window.location.pathname === "";
    if (isHome) {
      scrollToSection("services");
    } else {
      window.history.pushState({}, "", "/#services");
      window.dispatchEvent(new Event("popstate"));
      setTimeout(() => {
        scrollToSection("services");
      }, 100);
    }
  }}
>
  See what we do
</Button>
        </motion.div>

        {/* Right Column: 4 Feature Cards */}
        <motion.div
          className="about__features"
          variants={staggerContainer(0.1)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          {features.map((feature) => (
            <Card
              key={feature.id}
              interactive
              gradientBorder
              variants={fadeUp()}
              className="about__feature-card"
              onClick={handleNavigate(feature.href)}
              style={{ cursor: "pointer" }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <IconBox icon={feature.icon} />
                <ArrowUpRight size={18} className="text-muted" style={{ opacity: 0.6 }} />
              </div>
              <h3 className="card__title mt-5">{feature.title}</h3>
              <p className="card__text">{feature.text}</p>
            </Card>
          ))}
        </motion.div>
      </Container>
    </section>
  );
}

export default About;